<template>
    <Modal v-if="isOpen" class="LinkContentModal" size="lg" @close="close">
        <div class="mt-5 mb-4 flex items-center">
            <h3 class="m-0 flex-1">
                Vælg opslag for {{ interest.name }}
            </h3>
        </div>

        <PageLoader :loading="loading">
            <ContentsGrid :contents="contents" :rows="{ default: 2, sm: 3 }">
                <template v-slot:default="{ contents }">
                    <ToggleableInput
                        v-for="content of contents"
                        :key="content.id"
                        v-model="selected"
                        :model="content"
                    >
                        <template v-slot:default="{ isToggled, toggle }">
                            <button
                                type="button"
                                class="relative"
                                @click="toggle(!isToggled)"
                            >
                                <ContentCard
                                    :content="content"
                                    :class="{ '--selected': isToggled }"
                                />

                                <span
                                    class="absolute inset-2 z-10 cursor-pointer text-right"
                                >
                                    <CheckInput type="checkbox" :checked="isToggled" />
                                </span>
                            </button>
                        </template>
                    </ToggleableInput>
                </template>
            </ContentsGrid>

            <div
                class="-bottom-2 mt-4 -mb-8 -mx-4 px-4 py-3 bg-white border-gray-300 border-t relative rounded-b-lg sticky z-20"
            >
                <div class="flex items-center">
                    <span class="flex-1 text-xs">
                        Marker et eller flere opslag du har lavet for virksomheden, và tryk
                        derefter 'Færdig'
                    </span>
                    <button class="btn btn-success ml-4" @click="finish">
                        Færdig <i class="fa fa-check"></i>
                    </button>
                </div>
            </div>
        </PageLoader>
    </Modal>
</template>

<script type="text/babel">
import CheckInput from 'dashboard-js/components/utilities/CheckInput'
import ContentCard from 'dashboard-js/components/contents/ContentCard'
import ContentsGrid from 'dashboard-js/components/contents/ContentsGrid'
import HasLoadingState from 'dashboard-js/mixins/HasLoadingState'
import Modal from 'dashboard-js/components/Modal'
import PageLoader from 'dashboard-js/components/utilities/PageLoader'
import PreventClickFocus from 'dashboard-js/directives/PreventClickFocus'
import ToggleableInput from 'dashboard-js/components/utilities/ToggleableInput'

export default {
    components: {
        ContentsGrid,
        CheckInput,
        ToggleableInput,
        ContentCard,
        PageLoader,
        Modal,
    },

    directives: { PreventClickFocus },

    mixins: [HasLoadingState],

    props: {
        interest: {
            type: Object,
            required: true
        },
        contents: {
            type: Array,
            required: true
        },
        interestUserId: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            isOpen: false,
            selected: [],
            lastSelected: [],
        }
    },

    methods: {
        close() {
            this.isOpen = false
            this.selected = this.lastSelected
            this.resetState()
        },

        finish() {
            axios.post(route('pledge.attachContent', this.interestUserId), {
                content_ids: this.selected.map(content => content.id)
            }).then(response => {
                this.$emit('selected', this.selected)
                this.lastSelected = this.selected
                this.close()
            }).catch(error => {
                console.error('Error attaching contents:', error)
            })
        },

        open() {
            this.isOpen = true
        },

        resetState() {
            this.selected = []
            this.lastSelected = []
        }
    }
}
</script>

<style lang="less" type="text/less">
@import '~dashboard-less/variables';

.LinkContentModal {
    @apply .p-4;
}

.LinkContentModal .ResponsiveGrid {
    @apply items-start;
}

.LinkContentModal .ContentCard {
    @apply rounded-lg;

    &,
    .CoverImage {
        transition: all 0.2s;
    }
}

.LinkContentModal .ContentCard.--selected {
    border: 4px solid @brand-primary;

    .CoverImage {
        border-radius: 0.75rem;
    }
}

@media (hover: hover) {
    .LinkContentModal .ResponsiveGrid button:hover .ContentCard:not(.--selected) {
        box-shadow: 0 0 0 4px @brand-primary-light;
    }
}
</style>
